import { getDisplayDate } from '@billy/design-system'
import { TFunction } from 'i18next'

import { LocaleIdentifier } from '../../../../../../../../../../../../../types/localeIdentifier'
import { getDaysRemainingToEndOfMonth } from './getDaysRemainingToEndOfMonth'

interface GetDisplayDueDateLabelProps {
  dueDate: Date
  issueDate: Date
  locale: LocaleIdentifier
  numberOfDaysSelected: number
  t: TFunction
  withDueDate?: boolean
}

const getPaymentTermLabelTKey = (numberOfDaysSelected: number, issueDate: Date) => {
  const numberOfDaysUntilEndOfMonth = getDaysRemainingToEndOfMonth(issueDate)
  const isDueToday = numberOfDaysSelected === 0
  const isDueInOneDay = numberOfDaysSelected === 1
  const isDueUntilEndOfMonth = numberOfDaysSelected === numberOfDaysUntilEndOfMonth

  if (isDueToday) {
    return 'external_invoices.editor.form.field.due_date_and_payment_term.select_term.today.label'
  }

  if (isDueUntilEndOfMonth) {
    return 'external_invoices.editor.form.field.due_date_and_payment_term.select_term.end_of_month.label'
  }

  if (isDueInOneDay) {
    return 'external_invoices.editor.form.field.due_date_and_payment_term.select_term.within_one_day.label'
  }

  return 'external_invoices.editor.form.field.due_date_and_payment_term.select_term.within_days.label'
}

export const getDisplayDueDateLabel = ({
  dueDate,
  issueDate,
  locale,
  numberOfDaysSelected,
  t,
  withDueDate = true,
}: GetDisplayDueDateLabelProps): string => {
  const termLabel = t(getPaymentTermLabelTKey(numberOfDaysSelected, issueDate), {
    daysCount: numberOfDaysSelected,
  })

  if (!withDueDate) {
    return termLabel
  }

  return t('external_invoices.editor.form.field.due_date_and_payment_term.select_term.due_on.label', {
    dueDate: getDisplayDate(dueDate, locale),
    termLabel,
  })
}
